import { useQuery, useMutation, useQueryClient } from '../useQuery'
import { queryKeys } from '@/api/queryKeys'
import * as assetApi from '@/api/asset'
import type {
  CreateDeviceAssetRequest,
  CreateDeviceFromWorkOrderRequest,
  DeviceAssetPageParams,
} from '@/api/types/asset'

export function useDeviceAssets() {
  return useQuery({
    queryKey: queryKeys.deviceAssets,
    queryFn: assetApi.getDeviceAssets,
  })
}

export function useDeviceAssetPage(params: DeviceAssetPageParams = {}) {
  return useQuery({
    queryKey: [...queryKeys.deviceAssets, params],
    queryFn: () => assetApi.getDeviceAssetPage(params),
  })
}

export function useDeviceAsset(id: number) {
  return useQuery({
    queryKey: queryKeys.deviceAsset(id),
    queryFn: () => assetApi.getDeviceAsset(id),
    enabled: !!id,
  })
}

export function useCreateDeviceAsset() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateDeviceAssetRequest) => assetApi.createDeviceAsset(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.deviceAssets })
    },
  })
}

export function useCreateDeviceFromWorkOrder() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      workOrderId,
      data,
    }: {
      workOrderId: number
      data: CreateDeviceFromWorkOrderRequest
    }) => assetApi.createDeviceFromWorkOrder(workOrderId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.deviceAssets })
    },
  })
}
